// extracted by mini-css-extract-plugin
export default {"menuControls":"c-a_eX","menuControls_styleDefault":"c-a_eY","menuControls_styleRed":"c-a_eZ"};